import { FC } from 'react';
import { observer } from 'mobx-react-lite';
import { Container } from '@material-ui/core';
import { useStyles } from './styles';
import { ManagerDepartmentTable } from 'components/Tables/DepartmentUserTable/departmentManager';
const DepartmentManagerTable: FC = observer(() => {
  const classes = useStyles();
  return (
    <Container maxWidth='xl' className={classes.container}>
      <ManagerDepartmentTable />
    </Container>
  );
});

export default DepartmentManagerTable;
